<template>
  <b-form-select :options=competitions v-model=selected :disabled=disabled>
    <template slot="first">
      <option v-if=allowNull :value=null>-</option>
      <option v-else :value=null disabled>-- Wettbewerb wählen --</option>
    </template>
  </b-form-select>
</template>
<script>
export default {
  name: 'SelectCompetition',
  props: ['competitions', 'competitionId', 'disabled', 'allowNull'],

  data: function () {
    return {
      selected: null
    }
  },

  mounted: function () {
    this.selected = this.competitionId
  },

  watch: {
    competitionId: function (id) {
      this.selected = id
    },

    selected: function (id) {
      if (id === null) {
        this.$emit('change', id)
        return
      }

      this.competitions.forEach((competition) => {
        if (competition.value === id) {
          this.$emit('change', competition.value, competition.text)
        }
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/competitions/admin/SelectCompetition.vue